import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { NetworkTreeController } from '../controller/NetworkTreeController';
import { NodeData } from '../../../ui/gzTree/type';
import { TreeDetails } from '../types';

export class NetworkTreeWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: NetworkTreeController,
    });
  }

  set treeDetails(treeDetails: TreeDetails | undefined) {
    if (treeDetails !== undefined) {
      this.setAttribute('data-tree-details', JSON.stringify(treeDetails));
    } else {
      this.removeAttribute('data-tree-details');
    }
  }

  get treeDetails(): TreeDetails {
    return this.getValueFromAttribute(this, 'data-tree-details');
  }

  set rootNode(rootNode: NodeData) {
    if (rootNode) {
      this.setAttribute('data-root-node', JSON.stringify(rootNode));
    }
  }

  get rootNode(): NodeData {
    return this.getValueFromAttribute(this, 'data-root-node');
  }

  /**
   * When this boolean is true this component will search for the parent of the
   * node set in treeDetails. Otherwise, it will search for the treeDetails node.
   * @param value
   */
  set findParentNode(value: boolean) {
    if (value) {
      this.setAttribute('data-find-parent-node', '');
    } else {
      this.removeAttribute('data-find-parent-node');
    }
  }

  get findParentNode(): boolean {
    return this.hasAttribute('data-find-parent-node');
  }

  set hasActions(value: boolean) {
    if (value) {
      this.setAttribute('data-has-actions', '');
    } else {
      this.removeAttribute('data-has-actions');
    }
  }

  get hasActions(): boolean {
    return this.hasAttribute('data-has-actions');
  }
}
